import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { Button, textUtils } from '@valid-eval/shared-react-components';

import * as CommonTableCells from 'components/Tables/CommonTableCells';
import * as CommonTableHeaders from 'components/Tables/CommonTableHeaders';
import { Artifact } from 'data/features/artifactsTypes';

const { humanize } = textUtils;

const columnHelper = createColumnHelper<Artifact>();

const ActionsCell = ({ row, table }: CellContext<Artifact, any>) => {
  const meta = table.options.meta as any;
  const edit = meta.edit;

  return (
    <td className="text-center">
      <Button variant="link" className="px-2 py-1" onClick={() => edit(row.original)}>
        <i className="fa-regular fa-pen-to-square m-0" />
      </Button>
    </td>
  );
};

const OrderCell = ({ getValue, table }: CellContext<Artifact, any>) => {
  const meta = table.options.meta as any;
  const dragRef = meta.dragRef;

  return (
    <td className="text-center">
      <span>
        <button
          type="button"
          ref={dragRef}
          style={{ cursor: 'move' }}
          className="btn px-2 py-2 d-flex align-items-center"
        >
          <i className="fa-solid fa-grip-vertical text-muted"></i>
          <span className="ms-1 border rounded px-2 py-1 text-black01 bg-white02">
            {getValue() || 0}
          </span>
        </button>
      </span>
    </td>
  );
};

export const columns: ColumnDef<Artifact, any>[] = [
  columnHelper.accessor('sort_order', {
    id: 'Order',
    header: CommonTableHeaders.SimpleHeader,
    cell: OrderCell,
  }),
  columnHelper.accessor('teams_and_organizers_name', {
    id: 'Artifact Name',
    header: CommonTableHeaders.SimpleHeader,
    cell: (props) => <CommonTableCells.Text {...props} className="text-left w-100" />,
  }),
  columnHelper.accessor((row) => humanize(row.type), {
    id: 'Artifact Type',
    header: CommonTableHeaders.SimpleHeader,
    cell: (props) => <CommonTableCells.Text {...props} className="text-left" />,
  }),
  columnHelper.accessor('file_type_label', {
    id: 'File',
    header: CommonTableHeaders.SimpleHeader,
    cell: (props) => <CommonTableCells.Text {...props} className="text-left" />,
  }),
  columnHelper.accessor('required', {
    id: 'Required',
    header: CommonTableHeaders.SimpleHeader,
    cell: CommonTableCells.Boolean,
  }),
  columnHelper.accessor('id', {
    id: 'Actions',
    header: CommonTableHeaders.SimpleHeader,
    cell: ActionsCell,
  }),
];
